var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33024 8.46343C8.09276 9.4173 6.48741 8.90168 5.9668 8.77223L6.38828 7.08167C6.9089 7.21146 8.57843 7.46891 8.33024 8.46343Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56808 5.98906C8.35164 6.85627 7.01515 6.41553 6.58154 6.30748L6.9638 4.77417C7.39777 4.88222 8.7938 5.08404 8.56808 5.98906Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69236 0.209482C4.94322 -0.725484 1.14488 1.55702 0.210624 5.30722C-0.724698 9.05671 1.55745 12.8551 5.30623 13.7904C9.05643 14.7257 12.8548 12.4432 13.7894 8.69335C14.7247 4.94315 12.4426 1.14445 8.69236 0.209482ZM5.5594 4.72242C5.56903 4.55911 5.51269 4.35336 5.20139 4.27562C5.21351 4.26778 4.64369 4.13691 4.64369 4.13691L4.84837 3.31676L5.90742 3.58135L5.90671 3.58563C6.06575 3.62485 6.22978 3.66265 6.39738 3.70081L6.71224 2.43956L7.47961 2.63105L7.17116 3.86769C7.37691 3.91476 7.58445 3.96218 7.78628 4.01246L8.09258 2.78402L8.86067 2.97551L8.54616 4.23711C9.51571 4.57123 10.225 5.07188 10.0855 6.00328C9.98462 6.68507 9.60664 7.01526 9.10493 7.1308C9.79385 7.48952 10.1444 8.03973 9.81025 8.9936C9.3959 10.1782 8.41101 10.278 7.10127 10.0302L6.78355 11.3039L6.01547 11.1124L6.32927 9.85618C6.1303 9.80661 5.92668 9.75419 5.71737 9.69714L5.4025 10.9594L4.63513 10.768L4.95321 9.49174C4.77384 9.44575 4.59163 9.39725 4.40549 9.35054L3.40598 9.10128L3.78717 8.2223C3.78717 8.2223 4.35307 8.37278 4.34559 8.36173C4.5631 8.41522 4.65938 8.27365 4.69754 8.17916L5.5594 4.72242Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBit);
export default __webpack_public_path__ + "static/media/bit.c19f33afdbfac7bd51ea7196001b4fee.svg";
export { ForwardRef as ReactComponent };